import {
  RANK_INDICATORS_CHANGE,SHOW_MESSAGE,FETCH_RANK_INDICATORS_SUCCESS
} from "../constants/ActionTypes";

export const INIT_STATE = {
  value:{selected:[]}
};


export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case RANK_INDICATORS_CHANGE:
      return {...state,value:action.payload};
    case SHOW_MESSAGE: {
        return {
          ...state,
          showMessage: true,
        }
      }
    case FETCH_RANK_INDICATORS_SUCCESS:{
      return {...state,value:action.payload};
    }
    default:
      return state;
  }
}
